import React from "react";
import "../../cssfiles/homepage.css";
import { Typography } from "@mui/material";

export default function CustomTableHeading({ children }) {
    return (
        <Typography className='emission-config-heading' style={{ fontSize: '14px', fontWeight: 700, color: 'var(--SecondaryText)' }}>
            {children}
        </Typography>
    )
}